module.exports = __webpack_public_path__ + "img/google-block.eaa7e961.jpg";